import { BetaVersionEntry } from '@/features/BetaVersion';
import { isSupportOperatorFaceRoute, SupportOperatorEntry } from '@/features/SupportOperator';
import { Logo } from '@/shared/theme';
import { useLocation } from 'react-router-dom';

const FacePageHeader = () => {
  const location = useLocation();
  const isFaceRoute = isSupportOperatorFaceRoute(location.pathname);

  return (
    <div className="flex w-full items-center justify-between py-2 min-[769px]:py-3">
      <div className="flex items-center gap-3.5">
        <div className="h-7 w-[63.6px] shrink-0 overflow-hidden min-[769px]:h-9 min-[769px]:w-[295.855px] min-[769px]:overflow-visible">
          <Logo
            className="h-7 w-[230.109px] max-w-none min-[769px]:h-9 min-[769px]:w-[295.855px]"
            height={28}
          />
        </div>
        {isFaceRoute ? <BetaVersionEntry /> : null}
      </div>
      {isFaceRoute ? <SupportOperatorEntry /> : null}
    </div>
  );
};

export default FacePageHeader;